import { fetchSameOrigin } from '../Utils';
const updateMhd = memberId => {
  return fetchSameOrigin(`/members/${ memberId }/impersonate`, 'POST', {
    body: JSON.stringify({
      deep_link_path: `/member/${ memberId }/mhd/health_record` })
  }).then(r => r.json()).then(response => {
    window.open(response.impersonation_url);
    return true;
  });
};

export default updateMhd;
